// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/ElectronicTicket/ElectronicTicket.css
// module id = 1991
// module chunks = 0